"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDDWebTag = exports.getDDWebSha = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @param {object} windowParam - optional window object
 *
 * @return {string} Will return the current sha of your
 * application. This will return null when testing your
 * changes locally from dd-web but will return the correct
 * sha on staging and production.
 */
var getDDWebSha = function getDDWebSha() {
  var windowParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  return (0, _lodash["default"])(windowParam, '__dd.sha') || null;
};
/**
 * @param  {object} windowParam - optional window object
 *
 * @return {string} Will return the current tag of your 
 * application. This will return null when testing your 
 * changes locally from dd-web but will return the correct 
 * tag on staging and production.
 */


exports.getDDWebSha = getDDWebSha;

var getDDWebTag = function getDDWebTag() {
  var windowParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  return (0, _lodash["default"])(windowParam, '__dd.tag') || null;
};

exports.getDDWebTag = getDDWebTag;